// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// NoviCustomerDialog — ZDIEĽANÝ (vytiahnuté z CenoveView, Mirko 2026-06-25)
// Použité v Objednávke (CP má vlastnú internú kópiu — NEDOTÝKAŤ CP).
// Ústava 2415 search-then-create + 801 ORSR meno + 13 dedup IČO 409 + 21.5 ORSR/VIES
import React, { useState } from "react"
import TelefonInput from './TelefonInput.jsx'
import { COLORS, TYPO, SPACE, RADIUS } from "../theme.js"
import { useToast } from "./Toast.jsx"
import { fetchAuth } from "../auth/fetchAuth.js"
import { normPhone } from "../utils/phone.js"
import AdresaBunky from './AdresaBunky.jsx'   // PARTNER_ADRESA_V1: jeden blok adresy (0.J)
import { adresaSloz, adresaRozlozStavba, adresaZRegistra } from '../lib/adresa.js'

// cp_prefill_v1 (Mirko 13. 10. 2026: „matrix musí poznať polia konečne"): okno nového zákazníka
// si doteraz bralo len názov a VŠETKO OSTATNÉ pri otvorení vynulovalo — aj telefón a e-mail, ktoré
// doklad pod ním mal. Človek ich prepisoval ručne z obrazovky, ktorú mal pred očami.
// `prefill` nesie, čo doklad vie: meno, priezvisko, adresu, telefón, e-mail.
// Celé meno sa rozdelí na meno a priezvisko (posledné slovo = priezvisko) a okno sa prepne na
// fyzickú osobu — ale LEN keď to nevyzerá na firmu. Človek to vidí a môže prepísať.
const JE_FIRMA = (t) => /\b(s\.?\s?r\.?\s?o|a\.?\s?s|spol|k\.?\s?s|v\.?\s?o\.?\s?s|z\.?\s?z|o\.?\s?z|n\.?\s?o|s\.?\s?p|akciov|družstv|servis|stav|invest|group|company|trade)\b/i.test(String(t || ''))
const ROZDEL_MENO = (cele) => {
  const t = String(cele || '').replace(/\s+/g, ' ').trim()
  if (!t || JE_FIRMA(t)) return { meno: '', priezvisko: '', firma: true }
  const c = t.split(' ')
  if (c.length < 2) return { meno: '', priezvisko: '', firma: true }
  return { meno: c.slice(0, -1).join(' '), priezvisko: c[c.length - 1], firma: false }
}

export default function NoviCustomerDialog({ open, onClose, onCreated, prefillName = '', prefill = null, onExistujuci = null }) {   // PARTNER_KONTROLA_V1: onExistujuci = volajúci vie prijať existujúceho partnera
  const toast = useToast()
  // Zahranicne firmy (Mirko 28.7.): CZ a PL maju vlastne narodne registre —
  // SK = ORSR, CZ = ARES, PL = biela listina podatnikow VAT. VIES je len doplnok.
  const KRAJINY = [
    { kod: 'SK', nazov: 'Slovensko', pole: 'IČO',  dlzka: [6, 8],  vzor: 'napr. 36123456',   register: 'ORSR' },
    { kod: 'CZ', nazov: 'Česko',     pole: 'IČO',  dlzka: [8, 8],  vzor: 'napr. 00177041',   register: 'ARES' },
    { kod: 'PL', nazov: 'Poľsko',    pole: 'NIP',  dlzka: [10, 10],vzor: 'napr. 7740001454', register: 'MF PL' },
  ]
  const [kind, setKind] = useState('firma') // 'firma' | 'fyzicka'
  const [name, setName] = useState('')
  const [firstName, setFirstName] = useState('') // fyzická osoba: meno (Mirko 22.7.)
  const [lastName, setLastName] = useState('')   // fyzická osoba: priezvisko
  const [contactFirst, setContactFirst] = useState('') // firma: kontaktná osoba meno (nepovinné, Mirko 22.7.)
  const [contactLast, setContactLast] = useState('')   // firma: kontaktná osoba priezvisko
  const [ico, setIco] = useState('')
  const [dic, setDic] = useState('')
  const [icDph, setIcDph] = useState('')
  const [adr, setAdr] = useState(() => adresaRozlozStavba(''))   // PARTNER_ADRESA_V1: adresa v bunkách
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [country, setCountry] = useState('SK')
  const [hits, setHits] = useState(null) // ORSR výsledky (zoznam pri hľadaní podľa mena)
  const [busy, setBusy] = useState(false)
  const [lookingUp, setLookingUp] = useState(false)
  // PARTNER_KONTROLA_V1 (Mirko 26. 10. 2026: „aby sme overli vsetko a nerobil sa kopie zbytočne“; opravy po čitateľoch a kritikoch, zakazky 3581):
  // kým človek píše názov alebo IČO, Matrix pozrie, či partner už nie je v Matrixe (Použiť) a či ho pozná adresár MKsoftu (Prevziať → spárovanie).
  const [kontrola, setKontrola] = useState(null)
  const [kontrolaChyba, setKontrolaChyba] = useState(false)
  const [prevzaty, setPrevzaty] = useState(null)   // { kod, nazov, ico, text } z adresára MKsoftu — platí, len kým sedí IČO alebo názov
  const [dosledok, setDosledok] = useState([])     // 12.0 bod 3: čo sa stane po spárovaní (faktúry)
  const [dup409, setDup409] = useState(null)
  const icoCis = (t) => String(t || '').replace(/\D/g, '').replace(/^0+/, '')
  const hladanyText = kind === 'fyzicka' ? ((firstName.trim() && lastName.trim()) ? `${firstName} ${lastName}`.replace(/\s+/g, ' ').trim() : '') : name.trim()
  const hladaneIco = kind === 'firma' ? ico.trim() : ''
  React.useEffect(() => {
    if (!open) return
    setDup409(null)
    const q = hladanyText, i = hladaneIco
    if (q.length < 3 && i.length < 6) { setKontrola(null); setKontrolaChyba(false); return }
    let zive = true   // stará odpoveď neprepíše novšiu
    const t = setTimeout(() => {
      fetchAuth('/api/mksoft-vazby/adresar/hladaj?' + new URLSearchParams({ nazov: q.slice(0, 120), ico: i }).toString())
        .then(r => r.ok ? r.json() : Promise.reject(new Error(String(r.status))))
        .then(j => { if (zive) { setKontrola(j); setKontrolaChyba(false) } })
        .catch(() => { if (zive) { setKontrola(null); setKontrolaChyba(true) } })
    }, 400)
    return () => { zive = false; clearTimeout(t) }
  }, [open, hladanyText, hladaneIco])
  React.useEffect(() => {   // prevzatý záznam z MKsoftu sa zahodí, keď človek zmení IČO alebo názov (inak by sa spároval s cudzou firmou)
    if (!prevzaty) return
    const sedi = prevzaty.ico ? (kind === 'firma' && icoCis(ico) === icoCis(prevzaty.ico)) : hladanyText === prevzaty.text
    if (!sedi) { setPrevzaty(null); setDosledok([]) }
  }, [prevzaty, kind, ico, hladanyText])   // eslint-disable-line
  React.useEffect(() => {   // klávesy patria tomuto oknu: Esc zavrie len ho, Ctrl/Cmd+Enter a Ctrl/Cmd+S nejdú do formulára pod ním
    if (!open) return
    const f = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); onClose && onClose(); return }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'Enter' || e.key === 's' || e.key === 'S')) { e.preventDefault(); e.stopPropagation() }
    }
    window.addEventListener('keydown', f, true)
    return () => window.removeEventListener('keydown', f, true)
  }, [open, onClose])

  // cp_prefill_v1: pri otvorení sa polia PREDVYPLNIA z toho, čo doklad vie — nevynulujú sa.
  // `prefill` sa drží v ref, aby písanie v okne neprerušil nový render rodiča.
  const prefillRef = React.useRef(prefill)
  prefillRef.current = prefill
  React.useEffect(() => {
    if (open) {
      const p = prefillRef.current || {}
      const cele = String(p.name || prefillName || '').trim()
      const r = ROZDEL_MENO(p.firstName || p.lastName ? '' : cele)
      const meno = String(p.firstName || r.meno || '').trim()
      const priez = String(p.lastName || r.priezvisko || '').trim()
      const fyzicka = !!(meno || priez) && !String(p.ico || '').trim()
      setKind(p.kind || (fyzicka ? 'fyzicka' : 'firma'))
      setName(fyzicka ? '' : cele)
      setFirstName(meno); setLastName(priez)
      setContactFirst(''); setContactLast('')
      setIco(String(p.ico || '')); setDic(''); setIcDph('')
      setAdr(adresaRozlozStavba(p.address)); setPhone(String(p.phone || '')); setEmail(String(p.email || ''))
      setCountry('SK'); setHits(null); setBusy(false); setLookingUp(false)
      setKontrola(null); setKontrolaChyba(false); setPrevzaty(null); setDosledok([]); setDup409(null)   // PARTNER_KONTROLA_V1
    }
  }, [open, prefillName])

  if (!open) return null

  // PARTNER_KONTROLA_V1: existujúci partner namiesto kópie; prevzatie firmy z adresára MKsoftu
  const fmtDatum = (t) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(t || '')); return m ? `${+m[3]}. ${+m[2]}. ${m[1]}` : '' }
  const pouzi = async (id, meno) => {
    let c = { id, name: meno }
    try { const r = await fetchAuth('/api/customers/' + encodeURIComponent(id)); if (r.ok) c = await r.json() } catch (_) {}
    if (c.kos_at) { toast.error('Partner ' + (c.name || id) + ' je v koši — obnov ho v Partneroch'); return }
    toast.success('Vybraný existujúci partner ' + (c.name || id) + ' — kópia nevznikla')
    onExistujuci(c); onClose()
  }
  const prevezmi = (m) => {
    let text = hladanyText
    if (m.ico) { setKind('firma'); setName(m.nazov || ''); setIco(String(m.ico).replace(/\D/g, '')); text = '' }
    else if (kind === 'firma' && !m.fyzosoba) { setName(m.nazov || ''); text = String(m.nazov || '').trim() }
    if (m.obec) setAdr(a => ({ ...a, adresa_obec: a.adresa_obec || m.obec }))
    setPrevzaty({ kod: m.kod, nazov: m.nazov, ico: m.ico ? String(m.ico).replace(/\D/g, '') : '', text })
    setDosledok([])
    fetchAuth('/api/mksoft-vazby/partner/_/dosledok?kod=' + encodeURIComponent(m.kod)).then(r => r.ok ? r.json() : null)
      .then(j => setDosledok(j && Array.isArray(j.body) ? j.body : [])).catch(() => {})
  }

  // Hľadanie v ORSR
  const lookupOrsr = async (mode) => {
    setHits(null)
    let url = ''
    if (mode === 'ico') {
      const K = KRAJINY.find(x => x.kod === country) || KRAJINY[0]
      const v = ico.trim()
      if (v.length < K.dlzka[0] || v.length > K.dlzka[1]) {
        toast.error(`${K.pole} (${K.nazov}) = ${K.dlzka[0] === K.dlzka[1] ? K.dlzka[0] : K.dlzka[0] + '–' + K.dlzka[1]} číslic`); return
      }
      url = `/api/ico/lookup?ico=${encodeURIComponent(v)}&country=${K.kod}`
    } else if (mode === 'name') {
      if (!name.trim() || name.trim().length < 3) { toast.error('Zadaj aspoň 3 znaky názvu'); return }
      url = `/api/ico/lookup?name=${encodeURIComponent(name.trim())}`
    } else if (mode === 'vies') {
      if (!icDph.trim()) { toast.error('Zadaj IČ DPH (napr. SK2020123456)'); return }
      url = `/api/ico/lookup?ic_dph=${encodeURIComponent(icDph.trim())}`
    }
    setLookingUp(true)
    try {
      const r = await fetchAuth(url)
      const raw = await r.json()
      if (!r.ok || raw.error) { toast.error(`Register: ${raw.error || raw.message || 'zlyhalo'}`); return }
      const d = (raw && raw.data !== undefined) ? raw.data : raw
      // Backend môže vrátiť objekt (1 výsledok) alebo zoznam (search by name)
      if (Array.isArray(d)) {
        if (d.length === 0) { toast.warn('Žiadne výsledky.'); return }
        if (d.length === 1) { applyHit(d[0]); return }
        setHits(d)
        toast.info(`${d.length} výsledkov — vyber jeden`)
      } else if (d && (d.name || d.ico)) {
        applyHit(d)
      } else {
        toast.warn('Bez výsledku.')
      }
    } catch (e) {
      toast.error('Hľadanie zlyhalo: ' + e.message)
    } finally {
      setLookingUp(false)
    }
  }

  const applyHit = async (h) => {
    let full = h
    if (h && h.detailPath && !h.ico) {
      try {
        const rr = await fetchAuth('/api/ico/lookup?orsr_path=' + encodeURIComponent(h.detailPath))
        const rw = await rr.json()
        if (rr.ok && rw && rw.data) full = rw.data
      } catch (_) {}
    }
    if (full.name) setName(full.name)
    if (full.ico) setIco(full.ico)
    if (full.dic) setDic(full.dic)
    if (full.ic_dph) setIcDph(full.ic_dph)
    { const a = adresaZRegistra(full); if (a.adresa_ulica || a.adresa_obec) setAdr(a) }   // PARTNER_ADRESA_V1: sídlo z registra po bunkách
    if (full.country) setCountry(full.country)
    setHits(null)
    toast.success(`✓ ${full.name || 'výsledok'}`)
  }

  const fullName = kind === 'fyzicka' ? `${firstName.trim()} ${lastName.trim()}`.replace(/\s+/g, ' ').trim() : name.trim()
  const canSave = kind === 'fyzicka' ? !!(firstName.trim() && lastName.trim()) : !!name.trim()
  const save = async () => {
    if (kind === 'fyzicka') {
      if (!firstName.trim() || !lastName.trim()) { toast.error(!firstName.trim() && !lastName.trim() ? 'Doplň meno a priezvisko — obe sú povinné' : !lastName.trim() ? 'Doplň priezvisko — je povinné (ak si ho napísal do poľa Meno, presuň ho)' : 'Doplň meno — je povinné'); return }   // zakaznik_ulozit_v1
    } else if (!name.trim()) { toast.error('Názov firmy je povinný'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/customers', {
        method: 'POST',
        body: JSON.stringify({
          name: fullName,
          first_name: kind === 'fyzicka' ? firstName.trim() : null,
          last_name: kind === 'fyzicka' ? lastName.trim() : null,
          contact: kind === 'firma' ? (`${contactFirst.trim()} ${contactLast.trim()}`.replace(/\s+/g, ' ').trim() || null) : null,
          partner_type: kind === 'fyzicka' ? 'fyzicka_osoba' : 'firma',
          ico: kind === 'firma' ? (ico.trim() || null) : null,
          dic: kind === 'firma' ? (dic.trim() || null) : null,
          ic_dph: kind === 'firma' ? (icDph.trim() || null) : null,
          address: adresaSloz(adr) || null, ...adr,   // PARTNER_ADRESA_V1: bunky + poskladaný riadok
          phone: phone.trim() || null,
          email: email.trim() || null,
        }),
      })
      const d = await r.json()
      if (r.status === 409) {   // PARTNER_KONTROLA_V1: povedz, kto to je, a ponúkni ho (56.11.3); partnera v koši nie
        setDup409({ id: d.existingId || '', sprava: d.message || 'Partner už existuje.', kos: !!d.v_kosi })
        setBusy(false); return
      }
      if (!r.ok) { toast.error(d.error || 'Vytvorenie zlyhalo'); setBusy(false); return }
      toast.success(`✓ Vytvorený zákazník ${d.name}`)
      if (prevzaty) {   // PARTNER_KONTROLA_V1: prevzatý z adresára MKsoftu (IČO alebo názov stále sedí) → spárovať
        const chyba = (t) => toast.error('Partner je založený, ale spárovanie s MKsoftom sa nepodarilo' + (t ? ': ' + t : '') + ' — sprav ho v Riadenie › Prepojenia s MKsoftom')
        try {
          const rp = await fetchAuth('/api/mksoft-vazby/partner/' + encodeURIComponent(d.id) + '/sparovat', { method: 'POST', body: JSON.stringify({ kod: prevzaty.kod }) })
          const jp = await rp.json().catch(() => ({}))
          if (rp.ok) { d.mksoft_firmaid = prevzaty.kod; toast.success('Spárovaný s MKsoftom (' + prevzaty.kod + ')' + (jp.faktury_priradene ? ' · priradených faktúr: ' + jp.faktury_priradene : '')) }
          else chyba(jp.error || ('chyba ' + rp.status))
        } catch (e) { chyba('spojenie zlyhalo') }
      }
      onCreated(d)
      onClose()
    } catch (e) {
      toast.error('Chyba: ' + e.message)
    } finally {
      setBusy(false)
    }
  }

  const inpStyle = { width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`,
    borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', boxSizing: 'border-box' }
  const kindBtn = (active) => ({
    padding: '8px 14px', border: `1px solid ${active ? COLORS.brand : COLORS.line}`,
    background: active ? COLORS.brand : COLORS.bg, color: active ? '#fff' : COLORS.text,
    borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: TYPO.weights.semibold,
    fontSize: TYPO.sizes.sm, fontFamily: 'inherit', flex: 1,
  })
  const searchBtn = { padding: '8px 14px', border: `1px solid ${COLORS.line}`,
    background: COLORS.bg, color: COLORS.brand, borderRadius: RADIUS.sm, cursor: 'pointer',
    fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', whiteSpace: 'nowrap' }
  // PARTNER_KONTROLA_V1
  const miniBtn = { padding: '4px 10px', border: `1px solid ${COLORS.brand}`, background: COLORS.bg, color: COLORS.brand, borderRadius: RADIUS.sm,
    cursor: 'pointer', fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, fontFamily: 'inherit', whiteSpace: 'nowrap' }
  const nadpisK = { fontSize: TYPO.sizes.xs, color: COLORS.muted, margin: '4px 0' }
  const riadokK = { display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderTop: `1px solid ${COLORS.line}` }
  const dovodText = (z) => z.v_kosi ? ' · v koši' : z.dovod === 'ico' ? ' · rovnaké IČO — je to on' : z.dovod === 'ine_ico' ? ' · podobný názov, iné IČO — over' : ' · podobný názov — je to on?'
  const dovodFarba = (z) => z.dovod === 'ico' && !z.v_kosi ? '#15803d' : '#b45309'

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: SPACE.md }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ width: 560, maxWidth: '100%', background: COLORS.bg,
        borderRadius: RADIUS.lg, padding: SPACE.lg, fontFamily: TYPO.family, maxHeight: '90vh', overflow: 'auto' }}>
        <h3 style={{ margin: 0, marginBottom: SPACE.md }}>+ Nový zákazník</h3>

        {/* Toggle typ */}
        <div style={{ display: 'flex', gap: 6, marginBottom: SPACE.md }}>
          <button onClick={() => setKind('firma')} style={kindBtn(kind === 'firma')}>Firma (s IČO)</button>
          <button onClick={() => {
            // pri prepnutí na fyzickú osobu rozdeľ už zadaný názov na meno + priezvisko (Mirko 22.7.)
            if (!firstName && !lastName && name.trim()) { const p = name.trim().split(/\s+/); setFirstName(p[0] || ''); setLastName(p.slice(1).join(' ')) }
            setKind('fyzicka')
          }} style={kindBtn(kind === 'fyzicka')}>Fyzická osoba / Cudzinec</button>
        </div>

        {/* Názov firmy (firma) / Meno + Priezvisko (fyzická osoba) */}
        {kind === 'firma' ? (
          <div style={{ marginBottom: SPACE.sm }}>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Názov firmy *</div>
            <div style={{ display: 'flex', gap: 6 }}>
              <input value={name} onChange={e => setName(e.target.value)} style={{ ...inpStyle, flex: 1 }}
                placeholder="napr. WEBER, s.r.o." autoFocus />
              <button onClick={() => lookupOrsr('name')} disabled={lookingUp || !name.trim()} style={searchBtn}>
                {lookingUp ? '…' : 'Hľadať v ORSR'}
              </button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: SPACE.sm }}>
            <div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Meno *</div>
              <input value={firstName} onChange={e => setFirstName(e.target.value)} style={inpStyle}
                placeholder="napr. Ján" autoFocus />
            </div>
            <div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Priezvisko *</div>
              <input value={lastName} onChange={e => setLastName(e.target.value)} style={inpStyle}
                placeholder="napr. Novák" />
            </div>
          </div>
        )}

        {/* ORSR výsledky pri hľadaní podľa mena */}
        {hits && hits.length > 0 && (
          <div style={{ marginBottom: SPACE.md, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, padding: SPACE.sm, background: COLORS.bgSoft }}>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 6 }}>Vyber firmu:</div>
            {hits.map((h, i) => (
              <button key={i} onClick={() => applyHit(h)} style={{
                display: 'block', width: '100%', textAlign: 'left', padding: '6px 10px', marginBottom: 4,
                border: `1px solid ${COLORS.line}`, background: COLORS.bg, borderRadius: RADIUS.sm,
                cursor: 'pointer', fontFamily: 'inherit', fontSize: TYPO.sizes.sm,
              }}>
                <strong>{h.name || '—'}</strong> {h.ico && <span style={{ color: COLORS.muted }}>· IČO {h.ico}</span>}
                {h.address && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>{h.address}</div>}
              </button>
            ))}
          </div>
        )}

        {/* IČO + ORSR (iba pre firmu) */}
        {kind === 'firma' && (
          <>
            {/* Krajina firmy — urcuje, v ktorom registri sa hlada (Mirko 28.7.) */}
            <div style={{ display: 'flex', gap: 6, marginBottom: SPACE.sm }}>
              {KRAJINY.map(K => (
                <button key={K.kod} type="button" onClick={() => { setCountry(K.kod); setIco(''); setHits(null) }}
                  style={{
                    flex: 1, padding: '6px 0', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
                    fontFamily: 'inherit', cursor: 'pointer', borderRadius: RADIUS.sm,
                    border: `1px solid ${country === K.kod ? COLORS.brand : COLORS.line}`,
                    background: country === K.kod ? COLORS.navBg : '#fff',
                    color: country === K.kod ? COLORS.brandText : COLORS.muted,
                  }}>{K.nazov}</button>
              ))}
            </div>

            {(() => {
              const K = KRAJINY.find(x => x.kod === country) || KRAJINY[0]
              return (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 6, marginBottom: SPACE.sm }}>
                  <div>
                    <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>
                      {K.pole}{country !== 'SK' ? ' (' + K.nazov + ')' : ''}
                    </div>
                    <input value={ico} onChange={e => setIco(e.target.value.replace(/\D/g, '').slice(0, K.dlzka[1]))}
                      style={inpStyle} placeholder={K.vzor} inputMode="numeric" />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <button onClick={() => lookupOrsr('ico')} disabled={lookingUp || ico.length < K.dlzka[0]} style={searchBtn}>
                      {lookingUp ? '…' : K.register}
                    </button>
                  </div>
                </div>
              )
            })()}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 6, marginBottom: SPACE.sm }}>
              <div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>DIČ</div>
                <input value={dic} onChange={e => setDic(e.target.value)} style={inpStyle} />
              </div>
              <div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>IČ DPH</div>
                <input value={icDph} onChange={e => setIcDph(e.target.value)} style={inpStyle} placeholder="SK… / CZ… / PL…"
                  title="Staci napisat aj s prefixom (CZ00177041, PL7740001454) — Matrix sam pozna, do ktoreho registra ma ist." />
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <button onClick={() => lookupOrsr('vies')} disabled={lookingUp || !icDph.trim()} style={searchBtn}>
                  {lookingUp ? '…' : 'VIES'}
                </button>
              </div>
            </div>
          </>
        )}

        {/* PARTNER_KONTROLA_V1: kontrola, aby nevznikla kópia — hneď pod názvom a IČO, nech ju človek vidí, kým píše */}
        {(kontrola || dup409 || kontrolaChyba || prevzaty) && (
          <div style={{ marginBottom: SPACE.md, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, padding: SPACE.sm, background: COLORS.bgSoft, fontSize: TYPO.sizes.sm }}>
            <div style={{ fontWeight: TYPO.weights.semibold, marginBottom: 2 }}>Kontrola, aby nevznikla kópia</div>
            {kontrolaChyba && <div style={{ color: COLORS.muted }}>Kontrola sa nepodarila — pozri partnera v zozname sám.</div>}
            {dup409 && <div style={{ ...riadokK, color: '#b91c1c' }}><span style={{ flex: 1 }}>{dup409.sprava}{dup409.kos ? ' Je v koši — obnov ho v Partneroch.' : ''}</span>
              {!dup409.kos && (dup409.id && onExistujuci ? <button type="button" onClick={() => pouzi(dup409.id, '')} style={miniBtn}>Použiť existujúceho</button> : <span>vyber ho v zozname</span>)}</div>}
            {kontrola && (kontrola.matrix || []).length > 0 && <>
              <div style={nadpisK}>V Matrixe:</div>
              {kontrola.matrix.map(k => <div key={k.id} style={riadokK}>
                <span style={{ flex: 1 }}><b>{k.nazov}</b> <span style={{ color: COLORS.muted }}>({k.id}){k.ico ? ' · IČO ' + k.ico : ''}{k.obec ? ' · ' + k.obec : ''}{k.kod ? ' · MKsoft ' + k.kod : ''}</span><span style={{ color: dovodFarba(k), fontWeight: TYPO.weights.semibold }}>{dovodText(k)}</span></span>
                {k.v_kosi ? <span style={{ color: COLORS.muted }}>obnov ho v Partneroch</span> : onExistujuci ? <button type="button" onClick={() => pouzi(k.id, k.nazov)} style={miniBtn}>Použiť tohto</button> : <span style={{ color: COLORS.muted }}>vyber ho v zozname</span>}</div>)}
            </>}
            {kontrola && (kontrola.mksoft || []).length > 0 && <>
              <div style={nadpisK}>V adresári MKsoftu{kontrola.adresar && kontrola.adresar.nacitane_at ? ' (načítaný ' + fmtDatum(kontrola.adresar.nacitane_at) + ')' : ''}:</div>
              {kontrola.mksoft.map(m => <div key={m.kod} style={riadokK}>
                <span style={{ flex: 1 }}><b>{m.nazov}</b> <span style={{ color: COLORS.muted }}>{m.ico ? 'IČO ' + m.ico : (m.fyzosoba ? 'fyzická osoba' : 'kód ' + m.kod)}{m.obec ? ' · ' + m.obec : ''}</span>{m.dovod === 'ine_ico' && <span style={{ color: '#b45309', fontWeight: TYPO.weights.semibold }}> · iné IČO — over</span>}</span>
                {m.obsadene ? (onExistujuci && !m.obsadene.v_kosi ? <button type="button" onClick={() => pouzi(m.obsadene.id, m.obsadene.nazov)} style={miniBtn}>V Matrixe ako {m.obsadene.nazov} — použiť</button> : <span style={{ color: COLORS.muted }}>v Matrixe ako {m.obsadene.nazov}{m.obsadene.v_kosi ? ' (v koši)' : ''}</span>)
                  : prevzaty && prevzaty.kod === m.kod ? <span style={{ color: '#15803d', fontWeight: TYPO.weights.semibold }}>prevzatý</span>
                  : kontrola.smie_sparovat && m.dovod !== 'ine_ico' ? <button type="button" onClick={() => prevezmi(m)} style={miniBtn}>Prevziať</button> : null}</div>)}
            </>}
            {prevzaty && <div style={{ ...riadokK, background: '#ecfdf5', padding: '6px 8px', borderRadius: RADIUS.sm }}>
              <span style={{ flex: 1 }}><b>Po založení sa spáruje s MKsoftom:</b> {prevzaty.nazov} (kód {prevzaty.kod}){dosledok.length > 0 && <span style={{ display: 'block', color: COLORS.muted, fontSize: TYPO.sizes.xs }}>{dosledok.join(' ')}</span>}</span>
              <button type="button" onClick={() => { setPrevzaty(null); setDosledok([]) }} style={miniBtn}>Zrušiť</button></div>}
            {kontrola && !(kontrola.matrix || []).length && !(kontrola.mksoft || []).length && !dup409 && <div style={{ color: COLORS.muted }}>V Matrixe{kontrola.smie_mksoft ? ' ani v adresári MKsoftu' + (kontrola.adresar && kontrola.adresar.nacitane_at ? ' (načítaný ' + fmtDatum(kontrola.adresar.nacitane_at) + ')' : '') : ''} sa nenašiel — vznikne nový partner.</div>}
          </div>
        )}

        {/* Firma: kontaktná osoba meno + priezvisko (nepovinné, Mirko 22.7.) */}
        {kind === 'firma' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: SPACE.sm }}>
            <div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Kontaktná osoba — meno (nepovinné)</div>
              <input value={contactFirst} onChange={e => setContactFirst(e.target.value)} style={inpStyle} placeholder="napr. Ján" />
            </div>
            <div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Priezvisko (nepovinné)</div>
              <input value={contactLast} onChange={e => setContactLast(e.target.value)} style={inpStyle} placeholder="napr. Novák" />
            </div>
          </div>
        )}

        {/* Adresa + tel + email — vždy */}
        {/* PARTNER_ADRESA_V1 (21. 10. 2026): adresa v bunkách ako karta partnera, zamestnanca a zákazky */}
        <AdresaBunky hodnota={adr} zmen={setAdr} nadpis={kind === 'fyzicka' ? 'Adresa' : 'Sídlo'} style={{ marginBottom: SPACE.sm }}
          labelStyle={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }} inputStyle={{ padding: '8px 10px', borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm }} />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm, marginBottom: SPACE.md }}>
          <div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Telefón</div>
            <TelefonInput value={phone} onChange={setPhone} style={inpStyle} />
          </div>
          <div>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>E-mail</div>
            <input value={email} onChange={e => setEmail(e.target.value)} style={inpStyle} type="email" />
          </div>
        </div>

        {kind === 'fyzicka' && (
          <div style={{ padding: SPACE.sm, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`,
            borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.md }}>
            Fyzická osoba (Slovák aj cudzinec) — IČO sa nevyžaduje. Pre cudzinca uveď krajinu v adrese.
          </div>
        )}

        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <button onClick={onClose} disabled={busy} style={{ padding: '9px 18px', border: `1px solid ${COLORS.line}`,
            background: '#fff', borderRadius: RADIUS.md, fontSize: TYPO.sizes.base, cursor: 'pointer', fontFamily: 'inherit' }}>
            Zrušiť
          </button>
          <button onClick={save} disabled={busy} style={{ padding: '9px 18px', border: 'none',
            background: COLORS.brand, color: '#fff', borderRadius: RADIUS.md, fontSize: TYPO.sizes.base,
            cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 }}>
            {busy ? 'Vytváram…' : 'Vytvoriť'}
          </button>
        </div>
      </div>
    </div>
  )
}
